var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 361,
    viewBox: "0 0 294 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.3848 361H203.013C231.036 346.832 253.446 323.587 266.598 295.046C298.961 225.017 268.386 141.688 198.445 109.284C193.292 106.9 188 104.83 182.598 103.085L294 0H192.88L46.2398 132.269C32.1728 144.921 20.8305 160.312 12.9062 177.501C-18.7137 245.947 9.7813 327.109 76.3848 361ZM76.3317 206.903C92.5131 171.892 134.128 156.583 169.101 172.784C204.074 188.986 219.354 230.654 203.178 265.665C187.002 300.677 145.381 315.986 110.408 299.784C75.4351 283.583 60.1557 241.92 76.3317 206.903Z",
    fill: "#1C2138"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSix);
export default __webpack_public_path__ + "static/media/six.c281dc128b86001c370d35e48efd62c6.svg";
export { ForwardRef as ReactComponent };